import React from 'react';
import PricingComparison from './PricingComparison';
import './PricingPage.css';


const PricingPage = ({ onUpgrade }) => (
  <div className="pricing-page">
    <header className="pricing-page-header">
      <h1>Simple, one-time pricing</h1>
      <p className="pricing-page-lede">
        Get email alerts when we find your reference in an official NDVO decision
        publication, optional browser notifications, and all 13 premium planning tools. Pay once, use for the life
        of your application. No subscription, no auto-renewal.
      </p>
    </header>
    <PricingComparison onUpgrade={onUpgrade} />
    <section className="pricing-page-faq" aria-label="Pricing FAQ">
      <h2>Pricing questions</h2>
      <details>
        <summary>Why is the price ₹349?</summary>
        <p>
          The price reflects what it costs us to monitor daily NDVO publications,
          store your reference numbers, and send decision alerts by email and optional browser push.
          We keep it low so every Indian applicant can afford it.
        </p>
      </details>
      <details>
        <summary>Do I need to pay again later?</summary>
        <p>
          No. The ₹349 upgrade is a single one-time payment. There are no
          recurring charges, no subscription auto-renewals, and no hidden fees.
        </p>
      </details>
      <details>
        <summary>What if my visa case is closed?</summary>
        <p>
          Your alerts stop automatically — there is nothing to cancel. If you
          later apply for a new visa, you can reactivate by emailing us from
          your registered address.
        </p>
      </details>
      <details>
        <summary>How do refunds work?</summary>
        <p>
          Premium is a one-time, non-refundable purchase. Monitoring setup and
          tool access begin after payment verification, so we do not offer
          change-of-mind or unused-access refunds. Read our <a href="/refund">refund policy</a>{' '}
          for details and help with billing errors or service issues.
        </p>
      </details>
    </section>
  </div>
);

export default PricingPage;
